import { AnyType } from '@src/models/common';
import { BehaviorSubject, Observable } from 'rxjs';

/** string - id элемента, value - его значение */
type TValueList = { [x: string]: AnyType };

/** string - id значения, массив зависимостей */
type TExternalDependenceValueList = { [x: string]: AnyType };

export class LegoControllerRxjs<VL extends TValueList = AnyType, EDL extends TExternalDependenceValueList = AnyType> {
  /**
   * Список внешних зависимостей для редактирования элементов
   * При инициализации вроде как это не нужно
   */
  private externalDependenceList = {} as EDL;
  private valueList = {} as VL;
  private errorList = {} as { [x: string]: string[] };

  /** Subject - потому, что он предоставляет больший контроль над данными, но они обязательно должны быть приватны */
  private valueListSubject: BehaviorSubject<typeof this.valueList>;
  private externalDependenceListSubject: BehaviorSubject<typeof this.externalDependenceList>;
  private errorListSubject: BehaviorSubject<typeof this.errorList> = new BehaviorSubject(this.errorList);

  /**
   * Далее идут публичные объекты для подписок снаружи
   * ---> */
  public valueList$: Observable<VL>;
  public externalDependenceList$: Observable<EDL>;
  public errorList$ = this.errorListSubject.asObservable();
  /** <--- */

  constructor({
    defaultValueList,
    defaultExternalDependenceList,
  }: { defaultValueList?: VL; defaultExternalDependenceList?: EDL } = {}) {
    if (defaultValueList) {
      this.valueList = defaultValueList;
    }

    if (defaultExternalDependenceList) {
      this.externalDependenceList = defaultExternalDependenceList;
    }

    this.valueListSubject = new BehaviorSubject(this.valueList);
    this.valueList$ = this.valueListSubject.asObservable();

    this.externalDependenceListSubject = new BehaviorSubject(this.externalDependenceList);
    this.externalDependenceList$ = this.externalDependenceListSubject.asObservable();
  }

  /** Изменение определенного элемента
   * @param name имя элемента
   * @param value его новое значение
   */
  public onChange = (name: keyof VL, value: VL[typeof name]) => {
    this.valueList[name] = value;
    this.valueList = { ...this.valueList };

    this.valueListSubject.next(this.valueList);
  };

  /**
   * Изменение внешних зависимостей
   * @param name
   * @param value
   */
  public onChangeExternalDependence = (name: keyof EDL, value: EDL[typeof name]) => {
    this.externalDependenceList[name] = value;
    this.externalDependenceList = { ...this.externalDependenceList };

    this.externalDependenceListSubject.next(this.externalDependenceList);
  };

  public onChangeError = (name: string, value?: string[]) => {
    if (typeof value !== 'undefined') {
      this.errorList[name] = value;
    } else {
      delete this.errorList[name];
    }

    this.errorList = { ...this.errorList };

    this.errorListSubject.next(this.errorList);
  };

  public onChangeCommonError = (data: { [legoId: string]: string[] }) => {
    this.errorList = { ...data };
    this.errorListSubject.next(this.errorList);
  };

  /** Получение общего значения формы
   *  @deprecated используй getValues
   */
  getValueList() {
    return this.valueListSubject.getValue();
  }

  /** Получение текущего значения лего */
  getValues() {
    return this.valueList;
  }

  /** Получение текущего значения объекта с ошибками */
  getErrors() {
    return this.errorList;
  }

  /** Получение текущего значения объекта с внешними зависимостями */
  getExternalDependencies() {
    return this.externalDependenceList;
  }
}
